module.exports = __webpack_public_path__ + "static/usi-12e0a7952130583c1b7003bd9517bc91.png";